import blogClasses from './_card_blog_post.module.scss';
import { generateElementId } from 'music';

/**
 * Music Blog Post Card V3
 * @class
 */
export default class UaCardBlogPost extends HTMLElement {
  blogPost;
  category;
  externalLink;
  summary;
  thumbnail;
  type;

  static get observedAttributes() {
    return ['category', 'external-link', 'type'];
  }

  get classes() {
    return {
      blogPost: blogClasses['c-blog-post'],
      thumbnail: blogClasses['c-blog-post__thumbnail'],
      summary: blogClasses['c-blog-post__summary'],
      summaryContent: blogClasses['c-blog-post__summary-content'],
      summaryType: blogClasses['c-blog-post__summary-type'],
    };
  }

  get template() {
    return `<music-card-v3
        layout="semi-stack-top"
        class="${this.classes.blogPost}">
          <div class="${this.classes.thumbnail}" >
            <div slot="card-media">
              ${this.thumbnail.innerHTML}
            </div>
          </div>
          <l-stack-v3 gap="sm" slot="card-content"  class="${this.classes.summary}">
            <l-line-v3 align-y="start" align-x="between" >
              <div
                class="${this.classes.summaryContent}">
                  ${this.summary.innerHTML}
              </div>
              <sl-icon-button
                id="link-${this.id}"
                name="link-external"
                label="Go to external link"
                href="${this.externalLink}"
                target="_blank"
                onclick="recordOutboundLink(_, '${this.category}', '${this.externalLink}');return true;"
                class="u-txt-widget-red-700  u-txt-24">
              </sl-icon-button>
            </l-line-v3>
            ${this.type != null && this.type !== '-- Blank --' ? `<span class="${this.classes.summaryType}">${this.type}</span>`: ''}
          </l-stack-v3>
      </music-card-v3>`;
  }

  getCardElms() {
    this.blogPost = this;
    this.thumbnail = this.querySelector('[slot="post-thumbnail"]');
    this.summary = this.querySelector('[slot="card-post-summary"]');
  }

  render() {
    if (this.blogPost) {
      this.innerHTML = this.template;
    }
  }

  connectedCallback() {
    this.id = generateElementId('blog-post');
    this.getCardElms();
    this.render();
  }

  attributeChangedCallback(attrName, oldValue, newValue) {
    if (newValue !== oldValue) {
      if (['category', 'external-link', 'type'].includes(attrName)) {
        const propName = attrName.replace(/-([a-z])/g, (_, char) => char.toUpperCase());
        this[propName] = newValue;
        this.render();
      }
    }
  }
}
